import React from "react";
import NewGuests from "./components/NewGuests";
import SeatedGuests from "./components/SeatedGuests"; // 🔹 Import SeatedGuests
import { useWebSocket } from "./useWebSocket";

const Main = () => {
  useWebSocket();

  return (
    <div className="p-4 w-full max-w-screen-lg mx-auto">
      <h2 className="text-xl font-bold mb-4">Главная</h2>
      <NewGuests />
      <SeatedGuests /> {/* 🔹 Display the seated guests list */}
    </div>
  );
};

export default Main;
